import { useFormik } from "formik";
import { cultivoInitialValues } from "../constants/constants";
import { CultivoForm } from "./cutltivo.form";
import { cultivoValidations } from "../constants/validations";
import { useCultivo } from "../hooks/useCultivo";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";

const initialValues = cultivoInitialValues;
const validationSchema = cultivoValidations;

export const EditarCultivo = ({ reload, id_cultivo, onCancel }) => {
  const { editarCultivo, retriveCultivo } = useCultivo();
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (values) => {
    setIsLoading(true);
    try {
      await editarCultivo(id_cultivo, values.envases, values.cultivo);
      Swal.fire({
        icon: "success",
        title: "Cultivo modificado",
        timer: 1500,
      });
      reload();
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const {
    values,
    errors,
    touched,
    setValues,
    handleChange,
    setFieldValue,
    handleSubmit,
  } = useFormik({
    onSubmit,
    initialValues,
    validationSchema,
  });

  useEffect(() => {
    const getCultivo = async () => {
      try {
        const response = await retriveCultivo(id_cultivo);
        setValues({
          cultivo: response.cultivo,
          envases: response.envases,
        });
      } catch (error) {}
    };

    if (id_cultivo) {
      getCultivo();
    }
  }, [id_cultivo, setValues, retriveCultivo]);

  return (
    <CultivoForm
      values={values}
      errors={errors}
      touched={touched}
      handleChange={handleChange}
      setFieldValue={setFieldValue}
      handleSubmit={handleSubmit}
      loading={isLoading}
      isEditing={true}
      onCancel={onCancel}
    />
  );
};
